/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatDeniedMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler = function () {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(
		this,
		com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED
	);
};

$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
	com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler,
	"com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler"
);

/**
 * Process chat denied message.
 *
 * @param {com.inq.flash.messagingframework.Message} message - received message
 */
com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler.prototype.processMessage = function (message) {
	var deniedReason = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DENIED_REASON);

	if (deniedReason === com.inq.flash.client.data.MessageFields.DATA_CHAT_DENIED_WRONG_REQUEST_FOR_RECONNECT_REASON) {
		this.getController().handleChatLost();

		return;
	}

	var deniedMessageLabel = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TY_LABEL);

	if (deniedMessageLabel != null && deniedMessageLabel != "undefined" && deniedMessageLabel != "null") {
		com.inq.flash.client.chatskins.SkinControl.tYImageLabel = deniedMessageLabel;
	}

	this.getController().shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_DENIED);
	com.inq.flash.client.chatskins.SkinControl.doThankYou();
	com.inq.flash.client.chatskins.SkinControl.sendEventToAllAutomatons("onChatDenied");
	this.getController().disable();
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler;
